export default () => ({
  container: {
    height: 'calc(100vh - 64px)'
  }
});
